export default __webpack_public_path__ + "static/media/biofit-white-logo.54f46eea.svg";